"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const ModalSelectRoadmapClientNewBrand = ({ items, onAcceptPressed, ...rest }) => {
    const [itemsSelected, setItemsSelected] = React.useState();
    const onItemPressed = (item) => {
        if (itemsSelected?.map(e => e.code)?.includes(item.code) == true) {
            setItemsSelected(itemsSelected?.filter(e => e.code != item.code));
        }
        else {
            setItemsSelected([...(itemsSelected ?? []), ...[item]]);
        }
    };
    const renderItem = ({ item }) => (<native_base_1.Pressable onPress={() => {
            onItemPressed(item);
        }} mb="10" borderWidth={1} borderColor="colorLightGray1" borderRadius={theme_1.Sizes.configRadius} flexDirection="row" alignItems="center">
			<native_base_1.Text py={10} flex="1" mx="10" variant="body4">
				{item.name ?? ""}
			</native_base_1.Text>
			<native_base_1.Checkbox isChecked={itemsSelected?.map(e => e.code)?.includes(item.code)} value={""} mr={10}/>
		</native_base_1.Pressable>);
    return (<native_base_1.Modal {...rest} onClose={() => {
            setItemsSelected([]);
            rest.onClose?.();
        }}>
			<native_base_1.Modal.Content>
				<native_base_1.Modal.CloseButton />
				<native_base_1.Modal.Header>{`Seleccione`}</native_base_1.Modal.Header>
				<native_base_1.Modal.Body>
					<native_base_1.FlatList data={items} renderItem={renderItem} mb="10"/>
				</native_base_1.Modal.Body>
				<native_base_1.Modal.Footer>
					<native_base_1.Button onPress={() => {
            onAcceptPressed(itemsSelected ?? []);
            setItemsSelected([]);
        }}>
						Aceptar
					</native_base_1.Button>
				</native_base_1.Modal.Footer>
			</native_base_1.Modal.Content>
		</native_base_1.Modal>);
};
exports.default = ModalSelectRoadmapClientNewBrand;
